import { callApiAsync, getNationalizationTimeData, deleteNationalizationTime, getProviders } from '../../../services/apiService'

export const fetchTableData = async (
    providerId,
    mes,
    año,
    page,
    pageSize,
    setTableData,
    setTotalRecords,
    setLoading
) => {
    await callApiAsync(
        () => getNationalizationTimeData(providerId, mes, año, page, pageSize),
        (resp) => {
            // Manejar diferentes estructuras de respuesta del backend
            const data = resp?.data ?? resp;

            // Obtener el array de datos (puede venir como data, items, o directamente como array)
            const items = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.items)
                    ? data.items
                    : Array.isArray(data)
                        ? data
                        : [];

            // Obtener el total de registros
            const total = Number(data?.total) || Number(data?.totalRecords) || items.length;

            setTableData(items);
            setTotalRecords(total);
        },
        setLoading
    );
};
 
export const fetchProviders = async (setProviderOptions) => {
    await callApiAsync(
        () => getProviders(),
        (resp) => {
            const data = resp?.data ?? resp;
            const providers = Array.isArray(data) ? data : [];
            setProviderOptions([
                { name: "Todas", value: null },
                ...providers.map(p => ({ name: p.name, value: p.id }))
            ]);
        },
        null
    );
};

 export const deleteImport = async (importId, onSuccess) => {
    await callApiAsync(
        () => deleteNationalizationTime(importId),
        onSuccess,
        null
    );
};
